import { captureException } from '@sentry/browser';

import { serializeForm } from './serialization.js';
import { fetchConfig } from './fetch';

export const accessoriesSection = document.querySelector('#accessories');
const relatedTab = document.querySelector('[data-product-tab="related"]');

export const addEventToLoadAccessoriesMobile = () => {
  accessoriesSection
    .querySelector('toggle-mobile-navigation.product-accessories__button')
    // eslint-disable-next-line no-use-before-define
    .addEventListener('click', loadProductAccessoriesMobile);
};

export const loadProductAccessories = () => {
  const accessoriesContainer = accessoriesSection.querySelector('[data-accessories-handles]');
  const productHandles = accessoriesContainer.dataset.accessoriesHandles;
  const productLimit = parseInt(accessoriesContainer?.dataset.limit, 10);
  const productHandlesArr = [...new Set(productHandles.split(','))];
  const allAccessoriesBtn = accessoriesSection.querySelector('.product-accessories__button-container');

  const productsFetchArr = productHandlesArr.map((handle) =>
    fetch(`${window.location.origin}/products/${handle}?view=accessories`)
      .then((data) => data.ok && data.text())
      .then((response) => response)
      .catch(() => {
        // We don't capture exceptions here because a lot of products no longer exist
        // and it would just flood Sentry
        // captureException(err);
      })
  );

  if (productHandles === '') {
    accessoriesSection.remove();

    if (relatedTab) {
      relatedTab.remove();
    }

    return;
  }

  Promise.all(productsFetchArr).then((results) => {
    const filteredResults = results.filter(Boolean).slice(0, productLimit);

    if (filteredResults.length === 0) {
      accessoriesSection.remove();

      if (relatedTab) {
        relatedTab.remove();
      }

      return;
    }

    const filteredResultsString = filteredResults
      .map((el, index) => el.replace('{el.item}', `${index + 1}/${filteredResults.length}`))
      .join('');

    accessoriesContainer.innerHTML = filteredResultsString;
    allAccessoriesBtn.style.visibility = 'visible';
    accessoriesContainer.querySelectorAll('[data-type="add-to-cart-form"]').forEach((form) => {
      // eslint-disable-next-line no-use-before-define
      form.addEventListener('submit', productFormSubmit);
    });
  });
};

function productFormSubmit(evt) {
  evt.preventDefault();
  const form = evt.target;
  const cartNotification = document.querySelector('cart-notification');
  const accessoriesContainer = accessoriesSection?.querySelector('[data-accessories-handles]');
  const toogleMobileNav = accessoriesSection.querySelector('toggle-mobile-navigation');
  const templateName = accessoriesContainer?.dataset.template;

  const submitButton = evt.target.querySelector('[type="submit"]');

  submitButton.setAttribute('disabled', true);
  submitButton.classList.add('loading');

  if (templateName === 'product') {
    cartNotification.setActiveElement(document.activeElement);

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(form)),
      sections: cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        captureException(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  } else {
    const cartItemsRegistry = customElements.get('cart-items');
    const cartItems = new cartItemsRegistry();

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(form)),
      sections: cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
        cartItems.getSectionsToRender().forEach((section) => {
          // for the checkout buttons, check if they should be disabled, if so, do it without re-rendering them, else Exemptify will break
          if (section.id === 'main-cart-actions') {
            const buttonsHTML = cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

            const firstCheckoutButton = new DOMParser()
              .parseFromString(buttonsHTML, 'text/html')
              .querySelectorAll('[data-checkout-button]')[0];

            const buttonHidden = firstCheckoutButton.closest('.cart__ctas').classList.contains('button--hidden');
            const buttonDisabled = firstCheckoutButton.disabled;

            cartItems.updateCheckOutButtons(buttonHidden, buttonDisabled);
          } else {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });
        toogleMobileNav.remove();
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        loadProductAccessories();
        addEventToLoadAccessoriesMobile();
        cartItems.cartSubtotalReCalc();
        cartItems.disableLoading();
        cartItems.updateDeliveryEstimation(document.querySelectorAll('.quantity__input'));
      })
      .catch((e) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        cartItems.disableLoading();
        captureException(e);
      });
  }
}

const loadProductAccessoriesMobile = () => {
  const accessoriesContainer = accessoriesSection.querySelector('[data-accessories-handles]');
  const productHandles = accessoriesContainer.dataset.accessoriesHandles;
  const productHandlesArr = [...new Set(productHandles.split(','))];
  const accessoriesDrawer = document.querySelector('[data-accessories-drawer]');

  const accessoriesDrawerContainer = accessoriesDrawer.querySelector(
    '.menu-drawer__inner-container collapsible-element .ais-Hits'
  );

  if (!accessoriesDrawer.classList.contains('menu-drawer--is-active')) return;

  accessoriesDrawerContainer.innerHTML =
    '<div class="loader-wrapper"><div class="header__inner-loader">Loading...</div></div>';

  const productsFetchArr = productHandlesArr.map((handle) =>
    fetch(`${window.location.origin}/products/${handle}?view=accessories_mobile`)
      .then((data) => data.ok && data.text())
      .then((response) => response)
      .catch((err) => captureException(err))
  );

  Promise.all(productsFetchArr).then((results) => {
    const filteredResults = results.filter(Boolean);

    const filteredResultsString = filteredResults.join('');

    accessoriesDrawerContainer.innerHTML = `<ul class="ais-Hits-list">${filteredResultsString}</ul>`;
    accessoriesDrawerContainer.querySelectorAll('[data-type="add-to-cart-form"]').forEach((form) => {
      form.addEventListener('submit', productFormSubmit);
    });
  });
};
